export default function () {
  if (!this.$store.state?.user?.agency?.pagarmeId) {
    this.showMissingRecipientDialog = true
    return
  }
  this.loadProducts()

  if (this.$route.params.tripId) {
    this.tripId = this.$route.params.tripId
  }
}
